(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8643],{

/***/ 83790:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/search.9197ce09.svg","height":19,"width":18});

/***/ }),

/***/ 3282:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var isomorphic_dompurify__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(29238);
/* harmony import */ var isomorphic_dompurify__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(isomorphic_dompurify__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41609);
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(lodash_isEmpty__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _hooks_useIsSsr__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(7154);
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(27514);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(47956);








const BreadCrumb = (props)=>{
    const { data: { appliedCssClassNames ="" , items =[]  } , fullData ={}  } = props;
    const { carousel: { carouselComponentProperties: { appliedCssClassNames: carouselClassName = ""  } = {}  } = {}  } = fullData;
    const isSsr = (0,_hooks_useIsSsr__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)();
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    const getPathname = (url)=>{
        try {
            return new URL(url, "https://breadcrumb.invalid").pathname.replace(/\/+$/, "") || "/";
        } catch (e) {
            return "";
        }
    };
    const ITEM_TYPE = {
        breadcrumbList: "http://schema.org/BreadcrumbList",
        listItem: "http://schema.org/ListItem"
    };
    const [eventPageName, setEventPageName] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
    const [shortURLs, setShortURLs] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]);
    const [componentGroup, setComponentGroup] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]);
    const [columnClassNames, setColumnClassNames] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        const urls = items.map((navItem)=>navItem.url);
        Promise.all(urls.map(_utils_helper__WEBPACK_IMPORTED_MODULE_6__/* .getShortenedUrl */ .Ppy)).then((res)=>setShortURLs(res));
    }, [
        items
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (isSsr) return;
        setEventPageName(window.eventPageType);
    }, [
        isSsr
    ]);
    // #ToDo Hard coding zone value once received data from json will change
    const zone = "hero banner";
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (!lodash_isEmpty__WEBPACK_IMPORTED_MODULE_4___default()(fullData)) {
            Object.keys(fullData).forEach((key)=>{
                setComponentGroup((cmpGroup)=>[
                        ...cmpGroup,
                        fullData[key][":type"]
                    ]);
            });
        }
    }, [
        fullData
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (componentGroup.length > 0) {
            if (componentGroup.find((a)=>{
                return a === null || a === void 0 ? void 0 : a.includes(_constants__WEBPACK_IMPORTED_MODULE_7__.COMPONENT_TYPES.BREADCRUMB);
            }) && componentGroup.find((a)=>{
                return a === null || a === void 0 ? void 0 : a.includes(_constants__WEBPACK_IMPORTED_MODULE_7__.COMPONENT_TYPES.TEASER);
            }) && !(columnClassNames === null || columnClassNames === void 0 ? void 0 : columnClassNames.includes("aem-GridColumn aem-GridColumn--default--12"))) {
                setColumnClassNames((className)=>className += " aem-GridColumn aem-GridColumn--default--12");
            }
            if (componentGroup.find((a)=>{
                return a === null || a === void 0 ? void 0 : a.includes(_constants__WEBPACK_IMPORTED_MODULE_7__.COMPONENT_TYPES.BREADCRUMB);
            }) && componentGroup.find((a)=>{
                return a === null || a === void 0 ? void 0 : a.includes(_constants__WEBPACK_IMPORTED_MODULE_7__.COMPONENT_TYPES.CAROUSEL);
            }) && carouselClassName === "carousel-navigation-cta-left-right") {
                setColumnClassNames((className)=>className += " breadcrumb-overlay");
            }
            if (componentGroup.find((a)=>{
                return a === null || a === void 0 ? void 0 : a.includes(_constants__WEBPACK_IMPORTED_MODULE_7__.COMPONENT_TYPES.BREADCRUMB);
            }) && componentGroup.find((a)=>{
                return a === null || a === void 0 ? void 0 : a.includes(_constants__WEBPACK_IMPORTED_MODULE_7__.COMPONENT_TYPES.CAROUSEL);
            }) && componentGroup.find((a)=>{
                return a === null || a === void 0 ? void 0 : a.includes(_constants__WEBPACK_IMPORTED_MODULE_7__.COMPONENT_TYPES.CONTAINER);
            }) && !(columnClassNames === null || columnClassNames === void 0 ? void 0 : columnClassNames.includes("aem-GridColumn aem-GridColumn--default--12"))) {
                setColumnClassNames((className)=>className += " aem-GridColumn aem-GridColumn--default--12");
            }
        }
    }, [
        componentGroup
    ]);
    const getEventInfo = (navItem, index)=>{
        if (isSsr) {
            return JSON.stringify({
                clickInternalLinks: "true",
                eventAction: eventPageName + ":" + zone + ":breadcrumb",
                eventName: eventPageName + ":" + zone + ":breadcrumb",
                eventType: eventPageName,
                internalLinkName: navItem === null || navItem === void 0 ? void 0 : navItem.title,
                internalLinkPosition: "main content area",
                internalLinkType: window.storeLinkType ? window.storeLinkType : eventPageName + ":breadcrumb",
                internalLinkURL: navItem === null || navItem === void 0 ? void 0 : navItem.url,
                internalLinkZoneName: eventPageName + ":" + zone
            });
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "breadcrumb ".concat(appliedCssClassNames ? appliedCssClassNames : "").concat(columnClassNames),
            children: items.length > 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("nav", {
                id: "breadcrumb",
                className: "cmp-breadcrumb",
                "aria-label": "Breadcrumb",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ol", {
                    className: "cmp-breadcrumb__list",
                    itemScope: true,
                    itemType: ITEM_TYPE.breadcrumbList,
                    children: items.map((navItem, index)=>{
                        var ref, ref1;
                        const isLastItem = index === items.length - 1;
                        const destination = shortURLs[index];
                        const isActive = destination ? getPathname(destination) === getPathname(router.asPath) : Boolean(navItem.current || navItem.active);
                        const isShowroomSearch = /\/find-a-showroom(?:\.html)?\/?$/.test(getPathname(destination || navItem.url));
                        const title = isShowroomSearch && /^showrooms$/i.test((ref = navItem.title) === null || ref === void 0 ? void 0 : ref.trim()) ? "Find a Showroom" : navItem.title;
                        const shouldRenderSlash = !isActive && !isLastItem && !items[index + 1].active || ((ref1 = items[index + 1]) === null || ref1 === void 0 ? void 0 : ref1.current);
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                            className: "cmp-breadcrumb__item".concat(isActive ? " cmp-breadcrumb__item--active" : ""),
                            itemProp: "itemListElement",
                            itemScope: true,
                            itemType: ITEM_TYPE.listItem,
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                    href: shortURLs[index],
                                    className: "cmp-breadcrumb__item-link",
                                    itemProp: "item",
                                    "data-zone": zone,
                                    "aria-current": isActive ? "page" : undefined,
                                    "data-gbh-data-layer": !isSsr && getEventInfo(navItem, index),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        itemProp: "name",
                                        dangerouslySetInnerHTML: {
                                            __html: isomorphic_dompurify__WEBPACK_IMPORTED_MODULE_3___default().sanitize(title)
                                        }
                                    })
                                }),
                                " ",
                                shouldRenderSlash && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            className: "cmp-breadcrumb-slash",
                                            "aria-hidden": "true"
                                        }),
                                        "\xa0"
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                                    itemProp: "position",
                                    content: index + 1
                                })
                            ]
                        }, "breadcrumb-item-".concat(index));
                    })
                })
            }) : null
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (BreadCrumb);


/***/ }),

/***/ 79378:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ stickyNavHeader; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-sticky-el/lib/index.js
var lib = __webpack_require__(75198);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);
// EXTERNAL MODULE: ./src/components/ProductList/v2/Sort/index.jsx + 2 modules
var Sort = __webpack_require__(73812);
// EXTERNAL MODULE: ./node_modules/react-device-detect/dist/lib.js
var dist_lib = __webpack_require__(85518);
// EXTERNAL MODULE: ./public/icons/filter.svg
var filter = __webpack_require__(24495);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./utils/helper.js
var helper = __webpack_require__(27514);
// EXTERNAL MODULE: ./src/hooks/useDeviceWidthOnResize.js
var useDeviceWidthOnResize = __webpack_require__(56007);
;// CONCATENATED MODULE: ./src/components/ProductList/v2/ProductListView/StickyNav/showHide.jsx







const ShowHide = (param)=>{
    let { showFilter , staticTexts , setShowFilter , ariaHaspopup , ariaExpanded , page , type , isSearchTab , isFaq =false  } = param;
    const filterButtonClass = classnames_default()({
        "product-listing__filter-toggle-text": true,
        "product-listing__filter-toggle-text--show": !showFilter
    });
    const [width] = (0,useDeviceWidthOnResize/* useDeviceWidthOnResize */._)();
    const customProps = {};
    if (ariaHaspopup) Object.assign(customProps, {
        "aria-haspopup": dist_lib/* isTablet */.Em || dist_lib/* isMobile */.tq
    });
    if (ariaExpanded) Object.assign(customProps, {
        "aria-expanded": dist_lib/* isTablet */.Em || dist_lib/* isMobile */.tq ? false : showFilter
    });
    const getShowHideAnalyticsData = function(showFilterFlag) {
        let needJson = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
        let analyticsData = {
            eventAction: "support:help and faq:filters:".concat(showFilterFlag ? "show" : "hide", " filter"),
            eventName: "support:help and faq:filters:".concat(showFilterFlag ? "show" : "hide", " filter"),
            eventType: "navigation",
            eventMsg: "n/a",
            eventStatus: "n/a",
            internalLinkName: "".concat(showFilterFlag ? "show" : "hide", " filter"),
            internalLinkPosition: "support:help and faq",
            internalLinkType: "support:help and faq:".concat(showFilterFlag ? "show" : "hide"),
            internalLinkZoneName: "support:help and faq:filters",
            internalLinkURL: "n/a",
            clickInternalLinks: "true"
        };
        if (page === "search") {
            const pagetype = type === null || type === void 0 ? void 0 : type.toLowerCase();
            const isShowFilter = !showFilterFlag ? "show filters" : "hide filters";
            analyticsData = {
                eventAction: "search results:".concat(pagetype, ":filters:").concat(isShowFilter),
                eventName: "search results:".concat(pagetype, ":filters:").concat(isShowFilter),
                eventType: "navigation",
                eventStatus: "n/a",
                internalLinkName: "".concat(isShowFilter),
                internalLinkPosition: "search results page",
                internalLinkType: "search result page:".concat(isShowFilter),
                internalLinkZoneName: "search results:".concat(pagetype, ":filters"),
                internalLinkURL: "n/a",
                clickInternalLinks: "true"
            };
        }
        if (needJson) return analyticsData;
        return JSON.stringify(analyticsData);
    };
    const addAnalyticsForShowHideFilter = (showFilter)=>{
        const filterType = !showFilter ? "show" : "hide";
        const eventNameAndInternalLinkType = "plp:".concat(filterType);
        let eventInfo = {
            clickInternalLinks: "true",
            eventAction: "".concat(eventNameAndInternalLinkType, " filter"),
            eventName: "".concat(eventNameAndInternalLinkType, " filter"),
            eventType: "navigation",
            eventMsg: "n/a",
            eventStatus: "n/a",
            internalLinkName: "".concat(filterType, " filters"),
            internalLinkType: eventNameAndInternalLinkType,
            internalLinkURL: "n/a",
            internalLinkPosition: "plp",
            internalLinkZoneName: "plp:filters"
        };
        if (isSearchTab || isFaq) {
            eventInfo = getShowHideAnalyticsData(showFilter, true);
        }
        (0,helper/* pushAnalyticsObjToDataLayer */.zYT)(eventInfo);
        setShowFilter(!showFilter);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
        id: "showFilter",
        "aria-label": !showFilter ? staticTexts.showFilter : staticTexts.hideFilter,
        className: "product-listing__filter-toggle",
        onClick: ()=>addAnalyticsForShowHideFilter(showFilter),
        ...customProps,
        children: [
            width > 991 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                className: filterButtonClass,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        className: showFilter ? "show" : "hide",
                        children: staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.hideFilter
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        className: !showFilter ? "show" : "hide",
                        children: staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.showFilter
                    })
                ]
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                src: filter/* default */.Z === null || filter/* default */.Z === void 0 ? void 0 : filter/* default.src */.Z.src,
                className: "product-listing__filter-toggle-icon",
                alt: "Toggle Filter"
            })
        ]
    });
};
/* harmony default export */ var showHide = (ShowHide);

// EXTERNAL MODULE: ./src/hooks/useWindowResize.js
var useWindowResize = __webpack_require__(18216);
// EXTERNAL MODULE: ./public/icons/close.svg
var icons_close = __webpack_require__(653);
// EXTERNAL MODULE: ./public/icons/search.svg
var search = __webpack_require__(83790);
;// CONCATENATED MODULE: ./components/ProductList/v2/ProductListView/StickyNav/stickyNavHeader.jsx








const StickyNavHeader = (param)=>{
    let { staticTexts ={} , totalResults =0 , showFilter =false , sorts , selectedSort , setShowFilter =()=>{} , handleSort =()=>{} , isSearchTab , page , type ="" , searchKeyword ="" , onSearch , pageId , showTotal =true , isFaq =false  } = param;
    const [navSticky, setNavSticky] = (0,react.useState)(false);
    const [width] = (0,useWindowResize/* default */.Z)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((lib_default()), {
        onFixedToggle: ()=>setNavSticky(!navSticky),
        className: "product-listing__sticky-nav-wrap",
        stickyStyle: {
            zIndex: 9,
            width: "".concat(width, "px")
        },
        stickyClassName: "sticky sticky-plp-listing",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "container-fluid product-listing__sticky-nav ".concat(navSticky && "product-listing__sticky-nav--shadow"),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {}),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "product-listing__row ".concat(isSearchTab && "search-result__search-flex"),
                    children: [
                        navSticky && width < 813 && isSearchTab && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "search-result__search-wrap",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        role: "presentation",
                                        src: search/* default.src */.Z.src,
                                        alt: "search-icon"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                    type: "text",
                                    value: searchKeyword,
                                    onChange: (e)=>onSearch(e.target.value)
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    onClick: ()=>onSearch("", false),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: icons_close/* default.src */.Z.src,
                                        alt: "close-icon"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "container kf-react-plp-container",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "product-listing__row",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "product-listing__col product-listing__controls ".concat(isSearchTab && "search-result__sticky-search-pd"),
                                    children: [
                                        isSearchTab ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                                            "aria-label": totalResults + staticTexts.resultsCaps,
                                            className: "product-listing__total",
                                            children: [
                                                totalResults === null || totalResults === void 0 ? void 0 : totalResults.toLocaleString(),
                                                " ",
                                                staticTexts.resultsCaps
                                            ]
                                        }) : showTotal ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                                            "aria-label": staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.totalResults,
                                            className: "product-listing__total",
                                            children: [
                                                totalResults,
                                                " ",
                                                staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.results
                                            ]
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {}),
                                        navSticky && width > 812 && isSearchTab && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "search-result__sticky-search",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                        role: "presentation",
                                                        src: search/* default.src */.Z.src,
                                                        alt: "search-icon"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                    type: "text",
                                                    defaultValue: searchKeyword,
                                                    onChange: (e)=>{
                                                        var ref;
                                                        return onSearch(e === null || e === void 0 ? void 0 : (ref = e.target) === null || ref === void 0 ? void 0 : ref.value);
                                                    }
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    onClick: ()=>onSearch(""),
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                        src: icons_close/* default.src */.Z.src,
                                                        alt: "close-icon"
                                                    })
                                                })
                                            ]
                                        }),
                                        !pageId ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                                            className: "sorting-section ".concat(isFaq && "px-1"),
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "product-listing__fillter_sort",
                                                    children: staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.filterSort
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(showHide, {
                                                    showFilter: showFilter,
                                                    staticTexts: staticTexts,
                                                    setShowFilter: setShowFilter,
                                                    isSearchTab: isSearchTab,
                                                    page: page,
                                                    type: type,
                                                    isFaq: isFaq
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Sort/* default */.Z, {
                                                    tabIndex: "0",
                                                    data: sorts,
                                                    selectedSort: selectedSort,
                                                    texts: staticTexts,
                                                    onChange: handleSort,
                                                    page: page,
                                                    selectedtab: type,
                                                    isSearch: isSearchTab
                                                })
                                            ]
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
                                    ]
                                })
                            })
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var stickyNavHeader = (StickyNavHeader);


/***/ }),

/***/ 57633:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _components_ProductList_v2_ProductListView_Pagination_LoadMore__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(75455);
/* harmony import */ var _components_ProductList_v2_ProductListView_Pagination_Pagination__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47537);




const ProductPagination = (props)=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ProductList_v2_ProductListView_Pagination_LoadMore__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                ...props
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ProductList_v2_ProductListView_Pagination_Pagination__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                ...props
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ProductPagination);


/***/ }),

/***/ 56007:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ useDeviceWidthOnResize; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

const debounce = function(fn) {
    let delay = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1000;
    let timerId = null;
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        clearTimeout(timerId);
        timerId = setTimeout(()=>fn(...args), delay);
    };
};
const useDeviceWidthOnResize = (width)=>{
    const [deviceWidth, setDeviceWidth] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(width !== null && width !== void 0 ? width : 0);
    const handleOnResize = debounce(function() {
        setDeviceWidth(window.innerWidth);
    }, 300);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        setDeviceWidth(window.innerWidth);
        window.addEventListener("resize", handleOnResize);
        return ()=>{
            window.removeEventListener("resize", handleOnResize);
        };
    }, []);
    return [
        deviceWidth
    ];
};


/***/ }),

/***/ 85614:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9473);
/* harmony import */ var _store_features_authSlice__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2693);
/* harmony import */ var _store_features_cartSlice__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(64925);
/* harmony import */ var _hooks_usePrevious__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(97349);
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(27514);
/* harmony import */ var _utils_cart__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(87292);
/* harmony import */ var _hooks_useIsSsr__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(7154);
/* harmony import */ var _constants_config__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(19514);









const usePageAuth = ()=>{
    const isSsr = (0,_hooks_useIsSsr__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)();
    const dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useDispatch */ .I0)();
    const { access_token: accessToken  } = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)(_store_features_authSlice__WEBPACK_IMPORTED_MODULE_2__/* .selectAuthState */ ._9);
    const { cart: activeCart , isCartLoading  } = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)(_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_3__/* .selectCartState */ .xw);
    const prevToken = (0,_hooks_usePrevious__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        accessToken
    });
    // just for the dev testing purpose, if works fine then can only be proceed otherwise
    // one more pr will be raised to revert the change
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        let timeoutId;
        if (!isSsr) {
            timeoutId = setTimeout(()=>{
                if (!accessToken || !(0,_utils_helper__WEBPACK_IMPORTED_MODULE_5__/* .isGuestTokenValid */ .DVc)()) {
                    dispatch((0,_store_features_authSlice__WEBPACK_IMPORTED_MODULE_2__/* .getOktaToken */ .cs)({
                        type: "guest"
                    }));
                }
            }, 5000);
        }
        ;
        ()=>{
            clearTimeout(timeoutId);
        };
    }, [
        accessToken,
        isSsr
    ]);
    const callInitAuth = async ()=>{
        var ref;
        const config = await (0,_constants_config__WEBPACK_IMPORTED_MODULE_8__/* .getConfig */ .i)();
        const disableCommerce = (config === null || config === void 0 ? void 0 : (ref = config.general) === null || ref === void 0 ? void 0 : ref.disableCommerce) || false;
        if (disableCommerce) return;
        const hasNoActiveCart = ()=>{
            return (0,_utils_helper__WEBPACK_IMPORTED_MODULE_5__/* .isGuestTokenValid */ .DVc)() && accessToken && !(activeCart === null || activeCart === void 0 ? void 0 : activeCart.id) && !(activeCart === null || activeCart === void 0 ? void 0 : activeCart.cartExists);
        };
        if (hasNoActiveCart() || hasNoActiveCart() && (prevToken === null || prevToken === void 0 ? void 0 : prevToken.accessToken) !== accessToken) {
            if (!isCartLoading) {
                dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_3__/* .setCardStatus */ .YZ)(true));
                dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_3__/* .getCart */ .dv)()).unwrap().then((res)=>{
                    if ((0,_utils_helper__WEBPACK_IMPORTED_MODULE_5__/* .isGuestTokenValid */ .DVc)() && accessToken && (res === null || res === void 0 ? void 0 : res.cartExists) && (res === null || res === void 0 ? void 0 : res.cartExists) === "false" && (res === null || res === void 0 ? void 0 : res.error) === "No active cart exists.") {
                        (0,_utils_helper__WEBPACK_IMPORTED_MODULE_5__/* .getCurrency */ .zC$)().then((currency)=>{
                            const cartPayload = {
                                currency: currency,
                                taxMode: "ExternalAmount"
                            };
                            dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_3__/* .createCart */ .Bk)(cartPayload)).unwrap().then(()=>{
                                dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_3__/* .setCardStatus */ .YZ)(false));
                            });
                        });
                    } else {
                        dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_3__/* .setCardStatus */ .YZ)(false));
                    }
                });
            }
        }
        (0,_utils_cart__WEBPACK_IMPORTED_MODULE_6__/* .setCartLandingPagePath */ .NS)();
    };
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        if (isSsr) return;
        callInitAuth();
    }, [
        accessToken,
        isSsr
    ]);
};
/* harmony default export */ __webpack_exports__["Z"] = (usePageAuth);


/***/ }),

/***/ 97349:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

const usePrevious = (value)=>{
    const ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        ref.current = value;
    });
    return ref.current;
};
/* harmony default export */ __webpack_exports__["Z"] = (usePrevious);


/***/ }),

/***/ 68167:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"productListingFilterWrapper":"Filter_productListingFilterWrapper__ZU510","load":"Filter_load__3pshS"};

/***/ }),

/***/ 55266:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"productListWrapper":"ProductListView_productListWrapper__Q9ki_"};

/***/ }),

/***/ 58088:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"productListingSearchWrapper":"Sort_productListingSearchWrapper__wyBcb"};

/***/ })

}]);